import isURL from 'validator/lib/isURL';
import {Form} from 'antd';
import {
  Button,
  CommonInput,
} from '@/components/common-components/components/index';
import styles from './styles.module.scss';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {observer} from 'mobx-react-lite';
import {useTranslation} from 'next-i18next';

const Input = CommonInput;

interface Props {
  store: CurrentPageStore;
}

const UploadFromUrlForm = observer(({store}: Props) => {
  const [form] = Form.useForm<{url: string}>();
  const {t} = useTranslation('common');
  const onUploadHandler = async (url: string) => {
    store?.setIsCreateFromUrl(true);
    try {
      await store?.uploadFromUrl(url);
      store?.updateContentLoadedAt();
    } catch (e) {
      store?.setCurrentStep(2);
      throw e;
    } finally {
      store?.setCurrentStep(2);
    }
  };

  const handleSubmit = (value: {url: string}) => {
    onUploadHandler(value.url);
  };


  return (
    <Form className={styles.uploadForm} initialValues={{url: ''}} form={form} onFinish={handleSubmit}>
      <Form.Item
        name='url'
        rules={[
          {
            required: true,
            message: t('url-is-required'),
          },
          () => ({
            validator(_, value) {
              if (!value || isURL(value, {require_protocol: true})) {
                return Promise.resolve();
              }
              return Promise.reject(t('url-not-valid'));
            },
          }),
        ]}
        className={styles.urlinput}
      >
        <Input
          inputType='text'
          placeholder={t('example-com')}
        />
      </Form.Item>
      <Form.Item>
        <Button
          buttonType='default'
          className={styles.uploadBtn}
          loading={store?.isUploading}
        >
          {t('upload')}
        </Button>
      </Form.Item>
    </Form>
  );
});

export {UploadFromUrlForm};
